function getMostSuitableOrder(orders) {
    let value = 0;
    for (let i = 0; i <= orders.length; i++) {
        value = orders[i];
        if (value !== 0) {
            break;
        }
    }
    return value;
}

export { getMostSuitableOrder as g };
//# sourceMappingURL=getMostSuitableOrder-d0da2421.js.map
